"use client";

import { type ReactNode, createContext, useContext } from "react";

// Create context for workspace ID
const WorkspaceContext = createContext<string | undefined>(undefined);

interface WorkspaceIdProviderProps {
  children: ReactNode;
  workspaceId?: string;
}

export function WorkspaceIdProvider({
  children,
  workspaceId,
}: WorkspaceIdProviderProps) {
  return (
    <WorkspaceContext.Provider value={workspaceId}>
      {children}
    </WorkspaceContext.Provider>
  );
}

// Hook to consume the workspace ID
export function useCurrentWorkspaceId(): string | undefined {
  const context = useContext(WorkspaceContext);
  // It's okay if context is undefined initially or if no workspaceId is provided
  // Components using the hook should handle this state (e.g., disable queries)
  return context;
}
